export default "__VITE_ASSET__1pT_DUt1__"